import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type PanoramicInteriorClasses = 'interiorImg' | 'fullScreenToggleIcon' | 'interiorImageContainer';

const panoramicInteriorStyles = makeStyles<ISpcTheme, PanoramicInteriorClasses>(
  theme => ({
    interiorImageContainer: {
      width: '100%',
      position: 'relative',
      height: 600,
    },
    interiorImg: {
      width: '100%',
      height: '100%',
      position: 'relative',
      '& canvas': {
        position: 'absolute !important',
        width: '100% !important',
        height: '100% !important',
        objectFit: 'cover !important',
      },
    },
    fullScreenToggleIcon: {
      position: 'absolute',
      bottom: 5,
      right: 5,
      cursor: 'pointer',
      fill: theme.palette.common.white,
      zIndex: 2,
    },
  }),
  { name: 'Customise_PanoramicInterior' },
);

export default panoramicInteriorStyles;
